var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    "data-testid": "icon",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M14.78 12a.774.774 0 00-.307-.245 1 1 0 00-.419-.088H5.946a.995.995 0 00-.414.092.768.768 0 00-.301.244.567.567 0 00-.11.332c.001.117.04.23.112.332l4.054 5.356a.78.78 0 00.304.236 1 1 0 00.409.085 1 1 0 00.409-.085.78.78 0 00.303-.236l4.055-5.356a.572.572 0 00.118-.332.565.565 0 00-.106-.335z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M5.22 8c.074.102.18.186.307.245a1 1 0 00.419.088h8.108a.995.995 0 00.414-.092.77.77 0 00.301-.244.567.567 0 00.11-.332.569.569 0 00-.112-.332l-4.054-5.356a.78.78 0 00-.304-.236A1 1 0 0010 1.657a1 1 0 00-.409.086.78.78 0 00-.303.235L5.232 7.333a.571.571 0 00-.118.332.565.565 0 00.106.335z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsUpDown);
export default __webpack_public_path__ + "static/media/arrows-up-down.e0f5dca7e2c79c43fcfcf59e8c13395b.svg";
export { ForwardRef as ReactComponent };